import { useContext, useEffect } from "react"
import { Field } from "formik"

import { FormContext } from "../../context/formContext"
import { MultiSelect } from "primereact/multiselect"

import styles from "../../styles/Form.module.css"
import fieldVisibility from "../../helpers/fieldVisibility"

export default function TypeMultiSelect({ field, block, index }) {
  const form = useContext(FormContext)
  let isDisabled = form ? form.blocksSaved[block] : false
  isDisabled = field.read_only ? true : isDisabled

  const checkIfRequired = () => {
    try {
      return JSON.parse(field.field_validation.required[0])
    } catch (error) {
      return false
    }
  }
  const isRequired = checkIfRequired()

  useEffect(() => {
    // Register field as loading in FormContext
    form && form.registerLoadingField(field)

    // Notify FormContext that field is loaded
    form && form.completeLoadingField(field)

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const handleSelectOptions = ({ e, form }) => {
    if (e.value === null) {
      form.setFieldValue(field.field_name, "")
    } else {
      form.setFieldValue(field.field_name, e.value)
    }
  }

  return (
    <div
      className={styles.field}
      style={{
        order: index,
        display: fieldVisibility(field.field_visibility),
      }}
    >
      <label className={styles.label}>
        {field.field_label}
        {isRequired && <span className={styles.asterisk}> *</span>}
      </label>
      {field.field_description && (
        <div className={styles.description}>{field.field_description}</div>
      )}
      <div className={styles.value}>
        <Field name={field.field_name}>
          {({ field: formikField, meta, form }) => (
            <>
              <MultiSelect
                placeholder="Please select"
                id={field.field_name}
                name={formikField.name}
                value={formikField.value}
                onChange={(e) => handleSelectOptions({ e, form })}
                disabled={isDisabled}
                options={field.field_options}
              />
              {meta.touched && meta.error && (
                <div className={styles.errFieldMsg}>{meta.error}</div>
              )}
            </>
          )}
        </Field>
      </div>
    </div>
  )
}
